// extracted by mini-css-extract-plugin
module.exports = {"inputText":"_1djfOn-Zsz_iPUKaBFUd0t","container":"_1evzblu6T-ehlrkYHALDi0","checkmark":"_1HryED6UniIMbTZ5PwvA_y","outroWrapper":"_1VbrQ_RmJoFcYY01-Y2e4-"};